import {Hub, toServerSchedule} from 'yougile-model'

export const toggleTemplateState = (hub: Hub): void => {
  const rt = hub.data.repeatTemplate
  const isStopped = !rt.schedule
  if (isStopped) {
    rt.schedule =
      rt.savedSchedule ??
      toServerSchedule({
        type: 'daily',
        minute: 0,
        hour: 12
      })
  } else {
    rt.savedSchedule = rt.schedule
    delete rt.schedule
  }
  hub.commit()
}
